import DocViewer, { DocViewerRenderers } from '@cyntler/react-doc-viewer';
import { useEffect, useState } from 'react';
import { post } from '../Auths/AuthToken';

function DocsViewer({ docsId, close, patientId }) {
  const [docs, setDocs] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const response = await post(
          'api/patient/ManagePatientDocument/addEditDocumentPopup',
          {
            docId: docsId, // when editing a document
            table: '0', // when editing a document
            patientId: patientId,
            reconId: '',
          }
        );

        if (response?.status === 200) {
          let docsArr = [];
          if (response?.data?.filePath) {
            docsArr.push({ uri: response?.data?.filePath });
          }

          if (response?.data?.docPageArr?.length > 0) {
            response?.data?.docPageArr?.forEach((item) => {
              if (item?.filePath) {
                docsArr.push({ uri: item?.filePath });
              }
            });
          }

          if (docsArr.length === 0) {
            throw new Error('No valid documents found.');
          }

          setDocs(docsArr);
          setError(null); // Clear any previous errors
        } else {
          throw new Error('Failed to fetch documents.');
        }
      } catch (e) {
        console.error('Error fetching documents:', e.message);
        setError(e.message || 'Failed to load documents.');
      }
    })();
  }, [docsId, patientId]);

  return (
    <div className="modalBackground">
      <div
        className="center-popup"
        style={{
          backgroundColor: '#fff',
          position: 'absolute',
          width: '80%',
        }}
      >
        <div className="main-contnr-hdr flex-sec white-bg">
          <div className="hdr-pt-info">Document Viewer</div>
          <div className="close" onClick={close}>
            X
          </div>
        </div>
        <div
          style={{
            width: '100%',
            height: '500px',
            overflowX: 'hidden',
            overflowY: 'auto',
          }}
        >
          {error ? (
            <div
              style={{
                color: 'red',
                textAlign: 'center',
                marginTop: '20px',
              }}
            >
              <h3>Error</h3>
              <p>{error}</p>
            </div>
          ) : docs.length > 0 ? (
            <DocViewer
              documents={docs}
              initialActiveDocument={docs[0]}
              pluginRenderers={DocViewerRenderers}
              style={{
                width: '100%',
                height: '480px',
                overflowX: 'hidden',
                overflowY: 'auto',
              }}
            />
          ) : (
            <p style={{ textAlign: 'center', marginTop: '20px' }}>
              Loading documents...
            </p>
          )}
        </div>
      </div>
    </div>
  );
}

export default DocsViewer;
